import axios from '../../utils/axios';
import config from "../../config/Config";
import moment from 'moment'

class CommonService {

}

export default CommonService;